import React from "react";

export default class DystansKMFilter extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: {value: 0, label: 'WSZYSTKIE'}
        }

        this.filterOd = this.filterOd.bind(this);
        this.filterDo = this.filterDo.bind(this);
        this.isFiltered = this.isFiltered.bind(this);
    }

    filterOd(event) {
        this.setState({kmOd: event.target.value})
        if (event.target.value === 0) {
            this.props.filterHandler();
        } else {
            this.props.filterHandler({callback: this.isFiltered});
        }

    }

    filterDo(event) {
        this.setState({kmDo: event.target.value})
        if (event.target.value === 0) {
            this.props.filterHandler();
        } else {
            this.props.filterHandler({callback: this.isFiltered});
        }

    }

    isFiltered(targetValue) {

      //  console.log('target:', targetValue)

        if(Boolean(this.refs.kmInputOd.value) && Boolean(this.refs.kmInputDo.value)){
         //   console.log(this.refs.kmInputOd.value ,'<= ',targetValue && targetValue ,'<= ',this.refs.kmInputDo.value)
            return this.refs.kmInputOd.value <= targetValue && targetValue <= this.refs.kmInputDo.value
        }
        else if(Boolean(this.refs.kmInputOd.value)){
          //  console.log(this.refs.kmInputOd.value ,'<= ', targetValue)
            return this.refs.kmInputOd.value <= targetValue
        }
        else if(Boolean(this.refs.kmInputDo.value)){
        //    console.log(targetValue ,'<=', this.refs.kmInputDo.value)
            return targetValue <= this.refs.kmInputDo.value
        }
        else return targetValue

    }

    render() {
        return (
            <div>
                <input ref='kmInputOd' type='number' className='form-control' placeholder='Od'
                       value={this.state.kmOd} onChange={this.filterOd}/>
                <input ref='kmInputDo' type='number' className='form-control' placeholder='Do'
                       value={this.state.kmDo} onChange={this.filterDo}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/urzadModule/raport_sprzedazy_po_liniach/components/DystansKMFilter.js